import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=1d114081"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=1d114081&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports